
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/automatisierung/automatisierung-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="automatisierung-view">
        <hero-section
            background-image="/images/hero/automatisierung-hero.png"
            headline="Unsere Automatisierung"
            subheadline="Automatisierung mit FASE2"
            text="Wir haben automatisierte Prozesse."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="kraft-der-automatisierung">
                <hex-headline id="kraft-der-automatisierung" left text="Die Kraft der Automatisierung"></hex-headline>
                <p>
                    Bei <b>FASE2 Facility Services</b> setzen wir auf die Kraft der Automatisierung, um unseren Kunden den <b>bestmöglichen Service</b> zu bieten. 
                    Alle Unternehmen in unserer Unternehmensgruppe sind seit Jahren <b>digital aufgestellt</b>, 
                    sodass wir eine nahtlose und effiziente Zusammenarbeit gewährleisten können. 
                    Durch die Verbindung von Schnittstellen und eine <b>automatisierte Auftragsabwicklung</b> optimieren wir nicht nur 
                    unsere internen Prozesse, sondern bieten Ihnen auch <b>höchste Transparenz</b> und Effizienz.
                </p>
            </article>

            <hr>

            <article aria-labelledby="auftragsabwicklung">
                <hex-headline id="auftragsabwicklung" left text="Automatisierte Auftragsabwicklung – Vom Auftrag bis zur Rechnungsstellung"></hex-headline>
                <p>
                    Vom Moment der <b>Auftragsannahme</b> bis hin zur Rechnungsstellung arbeiten wir in einem <b>vollautomatisierten System</b>, 
                    das sicherstellt, dass jeder Schritt des Prozesses reibungslos abläuft. 
                    Dabei werden alle relevanten Partner digital eingebunden, informiert und aktiviert. 
                    Durch diese automatisierte Kommunikation zwischen den verschiedenen Schnittstellen innerhalb 
                    unseres <b>Unternehmensnetzwerks</b> können wir eine schnelle, präzise und <b>fehlerfreie Abwicklung</b> Ihrer Aufträge garantieren.
                </p>
            </article>

            <hr>

            <article aria-labelledby="digitale-prozesse">
                <hex-headline id="digitale-prozesse" left text="Optimale Arbeitsprozesse durch Digitalisierung"></hex-headline>
                <p>
                    Unsere <b>digitale Infrastruktur</b> sorgt dafür, dass alle Arbeitsprozesse optimal in Gang gesetzt und <b>nachhaltig optimiert</b> werden. 
                    Vom Eingang des Auftrags über die Planung und <b>Ausführung</b> bis hin zur Dokumentation der Arbeiten wird jeder Schritt digital 
                    erfasst und überwacht. Dies ermöglicht eine <b>effiziente Steuerung</b> und eine schnelle Umsetzung aller Maßnahmen, 
                    ohne dass <b>wichtige Details</b> übersehen werden.
                </p>
            </article>

            <hr>

            <article aria-labelledby="digitale-dokumentation">
                <hex-headline id="digitale-dokumentation" left text="Digitale Dokumentation – Alles transparent und nachvollziehbar"></hex-headline>
                <p>
                    Ein weiterer <b>Vorteil</b> der Automatisierung ist die <b>digitale Dokumentation</b>. 
                    Alle relevanten Informationen zu Ihrem Auftrag – wie z.B. Projektstatus, geplante Termine, durchgeführte Arbeiten und 
                    Rechnungsdetails – sind für Sie jederzeit einsehbar und nachvollziehbar. 
                    Ob für <b>Mieter</b>, Eigentümer oder <b>Verwalter</b> – unser transparentes System ermöglicht es allen Beteiligten, 
                    jederzeit den aktuellen Stand des Projekts zu überprüfen und sich auf eine <b>klare, verständliche Dokumentation</b> zu verlassen.
                </p>
            </article>

            <hr>

            <article aria-labelledby="warum-automatisierung">
                <hex-headline id="warum-automatisierung" left text="Warum Automatisierung wichtig ist"></hex-headline>
                <p>
                    <b>Automatisierung</b> hilft uns, die Effizienz unserer Prozesse zu steigern und gleichzeitig die Fehlerquote zu minimieren. 
                    Es ermöglicht uns, <b>ressourcenschonend</b> zu arbeiten, Kosten zu sparen und Ihnen als Kunde den <b>bestmöglichen Service</b> zu bieten. 
                    Sie profitieren von einer <b>schnelleren Bearbeitung</b>, einer ganzheitlichen Betreuung und einer <b>transparenten Kommunikation</b>, 
                    die es Ihnen ermöglicht, immer auf dem neuesten Stand zu bleiben.
                </p>
            </article>
        </div>
    </section>`,
      style: `automatisierung-view .automatisierung-view {
  margin: 0;
  padding: 0;
}
automatisierung-view .automatisierung-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
automatisierung-view .automatisierung-view .wrapper article {
  margin: 96px 0 0 0;
  padding: 0;
}
automatisierung-view .automatisierung-view .wrapper article:first-of-type {
  margin: 0 0 0 0;
}
automatisierung-view .automatisierung-view .wrapper aside {
  margin: 32px 0 0 0;
  padding: 0;
}
@media (max-width: 992px) {
  automatisierung-view .automatisierung-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  